import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@auth/AuthProvider';
import { VolunteerTeamsFetchResult } from '@data/interfaces/Volunteering/volunteerteam.interface';
import VolunteeringController from '@data/controller/VolunteeringController';

export default function useVolunteerTeams() {
  const auth = useAuth();
  const churchId = auth.churchId;

  const [teams, setTeams] = useState<VolunteerTeamsFetchResult | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!churchId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await VolunteeringController.fetchTeamsWithMembers(churchId, auth);
      if (response.error) {
        setError(response.error);
        setTeams(null);
      } else if (response.body) {
        setTeams(response.body);
      } else {
        setTeams(null);
      }
    } catch (err: any) {
      setError(err?.message || 'Failed to load teams');
      setTeams(null);
    } finally {
      setLoading(false);
    }
  }, [churchId, auth]);

  useEffect(() => {
    if (!churchId) return;

    void fetch();
  }, [churchId, fetch]);

  return { teams, loading, error, refetch: fetch } as const;
}
